import { render, staticRenderFns } from "./DeleteResourceModal.vue?vue&type=template&id=bd4d3ba6&scoped=true&"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d3ba6",
  null
  
)

export default component.exports